import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Shared/Common/Icon';
import { StyledExpandableListButton, StyledExpandableSectionList } from 'components/Shared/style';

class ExpandableSection extends PureComponent {
    state = {
        isExpand: this.props.isExpand
    };

    handleClickMore = () => {
        const { isExpand } = this.state;
        const { onExpand, onCollapse } = this.props;

        this.setState(prevState => ({ isExpand: !prevState.isExpand }));
        isExpand ? onCollapse() : onExpand();
    }

    render() {
        const {
            expandText,
            collapseText,
            children,
            itemsDefaultLength,
            itemsLength
        } = this.props;
        const { isExpand } = this.state;
        const isExpandable = !!(itemsLength
            && itemsDefaultLength
            && itemsDefaultLength < itemsLength);

        return (
            <StyledExpandableSectionList className="ui-content-channel-group-list">
                {children(isExpand)}
                {isExpandable && (
                    <StyledExpandableListButton
                        className="ui-expand-list"
                        onClick={this.handleClickMore}
                        role="presentation"
                    >
                        {(isExpand && collapseText) ? collapseText : expandText}
                        <Icon iconName={`Chevron${isExpand ? 'Up' : 'Down'}`} />
                    </StyledExpandableListButton>
                )}
            </StyledExpandableSectionList>
        );
    }
}

ExpandableSection.propTypes = {
    expandText: PropTypes.string,
    collapseText: PropTypes.string,
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func,
    isExpand: PropTypes.bool,
    children: PropTypes.any,
    itemsLength: PropTypes.number,
    itemsDefaultLength: PropTypes.number
};

ExpandableSection.defaultProps = {
    expandText: null,
    collapseText: null,
    onExpand: () => { },
    onCollapse: () => { },
    isExpand: false,
    children: null,
    itemsLength: null,
    itemsDefaultLength: null
};

export default ExpandableSection;
